const CoverPhotoUpdateModalHOC = props => {
    return props.children;
}

export default CoverPhotoUpdateModalHOC;
